// passing the path into variables

const destination1 = '/assets/lineaazul/destinos/chillan.webp'
const destination2 = '/assets/lineaazul/destinos/concepcion.webp'
// const destination3 = '/assets/kennybus/destinations/dest3.png'
// const destination4 = '/assets/kennybus/destinations/dest4.png'
// const destination5 = '/assets/kennybus/destinations/dest5.png'
// const destination6 = '/assets/kennybus/destinations/dest6.png'
// const destination7 = '/assets/kennybus/destinations/dest7.png'
// const destination8 = '/assets/kennybus/destinations/dest8.png'
// const destination9 = '/assets/kennybus/destinations/dest9.png'
const gallery1 = '/assets/lineaazul/gallery/galone.webp';
const gallery2 = '/assets/lineaazul/gallery/galtwo.webp';
const gallery3 = '/assets/lineaazul/gallery/galthree.webp';


const gallery = [gallery1, gallery2, gallery3];
const destination = [destination1, destination2];



const lineaazulSlides = {
	destination,
	gallery,
}

export default lineaazulSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/lineaazulSlides.js